import { Navigate } from "react-router";
import { useGetRoadCarrierQuery } from "../../../apis/RoadCarrier.api";
import { PrimaryRoadCarrier, RoadCarrier } from "../../../types/models/RoadCarrier";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const RoadCarrierScoped = () => {
    const {
        data,
    } = useGetRoadCarrierQuery(PrimaryRoadCarrier.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/road-carriers/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default RoadCarrierScoped;
